// Polite screen-reader announcements through the shell's one persistent live region (Layout's `org-announcer`).
// Pages call announce(); the Layout subscribes and renders the text. With no subscriber (tests, storybook) it is a no-op.
type Listener = (message: string) => void

const listeners = new Set<Listener>()
let toggle = false
const ZERO_WIDTH_SPACE = String.fromCharCode(0x200b)

export function subscribeAnnouncements(listener: Listener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/**
 * Announce a short message politely. Identical consecutive messages are still re-announced: alternating an invisible
 * suffix changes the text node so the live region fires again.
 */
export function announce(message: string): void {
  toggle = !toggle
  const text = toggle ? message : message + ZERO_WIDTH_SPACE
  listeners.forEach((l) => l(text))
}
